import React from "react";
import { Grid, Button } from "@material-ui/core";
import ReactApexChart from "react-apexcharts";

/**
 * Reusable chart component wrapper
 */
const ChartComponent = ({
  chartRef,
  title,
  chartId,
  options,
  series,
  showDownloadButton = false,
  onDownload,
  chartName,
}) => {
  return (
    <Grid item xs={12}>
      <div ref={chartRef}>
        <h2>{title}</h2>
        <ReactApexChart
          id={chartId}
          options={options}
          series={series}
          type={options?.chart?.type}
          height={options?.chart?.height}
          width={options?.chart?.width}
        />
      </div>
      {showDownloadButton && onDownload && (
        <div className="downloadChart-cont">
          <Button
            variant="contained"
            className="button"
            type="button"
            onClick={() => onDownload(chartRef, chartName)}
          >
            Download (PPT)
          </Button>
        </div>
      )}
    </Grid>
  );
};

export default ChartComponent;
